export const conditionCheckNumber = (value) => value * 1 >= 0 && value.match(/\d+$/);
// eslint-disable-next-line
export const conditionCheckEmail = (value) =>  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(value).toLowerCase());

export const checkNumber = (rule, value, callback) => {
  if (conditionCheckNumber(value)) {
    return callback();
  }
  callback('Dữ liệu phải có dạng số');
};

export const checkEmail = (rule, value, callback) => {
  if (conditionCheckEmail(value)) {
    return callback();
  }
  callback('Dữ liệu phải là email');
};
